module.exports = __webpack_public_path__ + "img/Spielen.d3812c7e.jpg";